var newModelCollection = require('./modelCollection');

function readOnlyModelCollection() {
	var collection = newModelCollection.apply(null, arguments);
	collection.isReadOnly = function() {return true;};
	return collection;
}

module.exports = readOnlyModelCollection;